<template>
  <div class="col-img">
    <img
      :src="columnProperties.value || DefaultImg"
      alt="brand logo"
      draggable="false"
      :style="styleProperty"
    />
  </div>
</template>

<script>
  import DefaultImg from '@/assets/images/icons/IconProfile.png';
  import { imageColumn } from '@/configs/dynamic-config/dynamic-column';
  import { computed } from '@vue/composition-api';

  export default {
    props: {
      columnProperties: Object,
    },
    setup(props) {
      const renderShape = (shape) => {
        switch (shape) {
          case 'circle':
            return '50%';
          case 'square':
            return '10%';
          default:
            return '0';
        }
      };

      const styleProperty = computed(() => {
        return {
          width:
            props.columnProperties.field.column_property.img_size_width !==
            '0px'
              ? props.columnProperties.field.column_property.img_size_width
              : imageColumn.img_size_width,
          height:
            props.columnProperties.field.column_property.img_size_height !==
            '0px'
              ? props.columnProperties.field.column_property.img_size_height
              : props.columnProperties.field.column_property.img_shape ==
                  'square' || 'sqaure'
              ? 'unset'
              : imageColumn.img_size_height,
          'border-radius': renderShape(
            props.columnProperties.field.column_property.img_shape ||
              imageColumn.img_shape
          ),
          objectFit:
            props.columnProperties.field.column_property.img_shape == 'circle'
              ? 'cover'
              : 'contain',
        };
      });

      return {
        styleProperty,
        DefaultImg,
        renderShape,
      };
    },
  };
</script>

<style scoped>
  .col-img {
    display: flex;
    justify-content: center;
    margin: auto;
  }
</style>
